import styled from 'styled-components';
import config from '../../../config';
import {useAuth} from '../../../contexts/UserContext';
import {PageMainTitle, SectionTitle} from '../../atoms/CommonParts';
import {Link} from 'react-router-dom';


const PageTopVenueNameLabel = styled.div`
  margin-top: 20px;
  span {
    font-size: 20px;
    font-weight: bold;
    line-height: 25px;
  }

`;

const PageTopVenueNameLink = styled.div`
  text-align: right;
  margin-top: 20px;
  margin-bottom: 20px;

  a {
    font-size: 14px;
    color: #000000;
    font-weight: bold;
    text-decoration: underline;
  }
`;

const PageTopVenueNameWrap = styled.div`
  border-bottom: 1px solid #000;
  margin-bottom: 40px;
  .venue-name-label {
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
  }
`;


export function PageTopVenueName({
}) {
  const {state} = useAuth();
  const venue = state.venue || null;
  if (!venue) {
    return '';
  }

  return (
      <PageTopVenueNameWrap>
        <PageMainTitle><span>Setup</span></PageMainTitle>
        <div className={'venue-name-label'}>Venue Name</div>
        <PageTopVenueNameLabel>
          <span>{venue.name}</span>
        </PageTopVenueNameLabel>
        <PageTopVenueNameLink>
          <Link
              to="/contact/"
              state={{
                category: 'Request to change my venue name',
              }}
          >
            Manage your account
          </Link>
        </PageTopVenueNameLink>
      </PageTopVenueNameWrap>
  );
}


const NotLoginedHeaderAreaElm = styled.div`
  padding: 35px 0 28px 0;
  @media ${config.layout.wide} {
    padding: 66px 0 60px 0;
  }
  border-bottom: 6px solid #000;
`;

export function NotLoginedHeaderArea({...props}) {
  return (
      <NotLoginedHeaderAreaElm {...props}>
        <div className="notlogin-sitelogo sitelogo"></div>
      </NotLoginedHeaderAreaElm>
  )
}